import i18n from '../../i18n'

const emptyValue = v => {
  return v == null || v.toString().trim() === ''
}

const requiredRules = (v) => [!emptyValue(v) || i18n.t('warnings.validation.required')]

export default requiredRules
